/* Worker Productivity Report (Harvesting) — fetches /api/report/worker/data and
   renders KPIs, charts and the worker -> dated-entry accordion table. Each worker
   row sums their harvesting output; expand to see per-day entries. When a single
   worker is selected, the charts switch to that worker's output by block.
   Columns/kpis/charts come from the server. (jQuery, like the rest of the app.) */
if (window.location.pathname.startsWith("/report/worker")) {
  (function () {
    const PALETTE = ['#10b981', '#3b82f6', '#a855f7', '#06b6d4', '#f59e0b', '#ec4899', '#14b8a6', '#f97316'];
    const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const f0 = n => Math.round(+n || 0).toLocaleString();
    const f1 = n => (+n || 0).toLocaleString(undefined, { maximumFractionDigits: 1 });
    const f2 = n => (+n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fdate = s => { const p = String(s || '').split('-'); return p.length === 3 ? (+p[2]) + ' ' + (MON[+p[1] - 1] || '') + ' ' + p[0] : (s || ''); };
    const fmtVal = (v, fmt) => {
      if (v === null || v === undefined || v === '') return '<span class="text-slate-300">—</span>';
      if (fmt === 'int') return f0(v);
      if (fmt === 'f1') return f1(v);
      if (fmt === 'f2') return f2(v);
      return String(v);
    };
    const statusChip = s => s === 'inactive'
      ? '<span class="chip bg-slate-200 text-slate-600">Inactive</span>'
      : '<span class="chip bg-blue-100 text-blue-700">Active</span>';

    // True when a KPI's rendered value is numerically zero (ignores '—', units, commas).
    const isZeroKpi = k => {
      const t = String(k.value || '').replace(/<[^>]*>/g, '').replace(/,/g, '').trim();
      if (t === '' || t === '—') return false;
      const num = parseFloat(t.replace(/[^0-9.\-]/g, ''));
      return !isNaN(num) && num === 0;
    };

    let charts = [];
    const clearCharts = () => { charts.forEach(c => c.destroy()); charts = []; };
    let current = null;

    // Resolve a column's raw value for a row (worker / entry / totals).
    function cellRaw(col, row) {
      switch (col.src) {
        case 'area_covered': return row.area_covered;
        case 'metric': return (row.metrics || {})[col.key];
        case 'derived': return (row.derived || {})[col.key];
        case 'date': return row.date;
        case 'block': return row.block;
        case 'sub_block': return row.sub_block;
        default: return null;
      }
    }
    function numCell(col, row) {
      let html = fmtVal(cellRaw(col, row), col.fmt);
      if (col.strong) html = '<b>' + html + '</b>';
      return `<td class="${col.align === 'l' ? 'l' : ''}">${html}</td>`;
    }
    function plainCell(col, row) {   // CSV (no HTML)
      const v = cellRaw(col, row);
      return (v === null || v === undefined) ? '' : String(v);
    }

    // When a single worker is selected, chart their output grouped by block instead
    // of the cross-worker charts (built client-side from the worker's entries).
    function workerBlockCharts(w) {
      const byBlock = {};
      (w.entries || []).forEach(e => {
        const b = e.block || '—';
        (byBlock[b] = byBlock[b] || { bunch: 0, area: 0 });
        byBlock[b].bunch += +((e.metrics || {}).total_bunch_count) || 0;
        byBlock[b].area += +e.area_covered || 0;
      });
      const labels = Object.keys(byBlock);
      const name = w.name || '';
      return [
        { title: 'Total bunches by block — ' + name, y: 'bunches', labels,
          datasets: [{ label: 'Bunches', data: labels.map(l => byBlock[l].bunch) }] },
        { title: 'Area covered by block — ' + name, y: 'ha', labels,
          datasets: [{ label: 'Area covered', data: labels.map(l => +byBlock[l].area.toFixed(2)) }] },
      ];
    }

    function render(p) {
      current = p;
      $('#wr-placeholder').addClass('hidden');
      $('#wr-results').removeClass('hidden');
      const cols = p.columns || [];
      const range = (p.from_date || '…') + ' → ' + (p.to_date || '…');
      $('#wr-note').html('<i class="bi bi-info-circle"></i> ' + (p.log_count || 0) + ' daily entries · ' +
        (p.worker_count || 0) + ' workers · ' + range +
        ' — one line per daily harvesting chit, grouped under each worker.');

      // KPIs (first card orange, zero red, rest green)
      $('#wr-kpis').html((p.kpis || []).map((k, i) => {
        const tone = i === 0 ? 'kpi-area' : (isZeroKpi(k) ? 'kpi-zero' : '');
        return `<div class="card ${tone} p-4"><div class="text-[11px] text-slate-400 uppercase">${k.label}</div>` +
          `<div class="text-2xl font-bold mt-1">${k.value}</div>` +
          `<div class="text-xs text-slate-400">${k.sub || ''}</div></div>`;
      }).join(''));

      // Charts — cross-worker by default; for a single selected worker, by block.
      const workers = p.workers || [];
      const single = !!($('#wr-worker').val()) && workers.length === 1;
      const cc = single ? workerBlockCharts(workers[0]) : (p.charts || []);
      $('#wr-charts').html(cc.map((c, i) =>
        `<div class="card p-5"><div class="font-semibold mb-3">${c.title}</div>` +
        `<canvas id="wr-ch${i}" height="150"></canvas></div>`).join(''));
      clearCharts();
      cc.forEach((c, i) => {
        const el = document.getElementById('wr-ch' + i);
        if (!el || !window.Chart) return;
        charts.push(new Chart(el, {
          type: 'bar',
          data: { labels: c.labels, datasets: (c.datasets || []).map((d, di) => ({
            label: d.label, data: d.data, borderRadius: 4,
            backgroundColor: PALETTE[di % PALETTE.length]
          })) },
          options: { plugins: { legend: { display: (c.datasets || []).length > 1, position: 'top', labels: { boxWidth: 12 } } }, scales: { y: { beginAtZero: true, title: { display: true, text: c.y } } } }
        }));
      });

      // Table head
      $('#wr-thead').html(cols.map(c => `<th class="${c.align === 'l' ? 'l' : ''}">${c.label}</th>`).join(''));

      $('#wr-empty').toggleClass('hidden', workers.length > 0);

      // Body: a worker row + its hidden dated-entry rows
      const blank = `<td><span class="text-slate-300">—</span></td>`;
      let html = '';
      workers.forEach((w, i) => {
        const n = (w.entries || []).length;
        html += `<tr class="grp-row" data-i="${i}">` + cols.map(c => {
          if (c.src === 'name') {
            const chev = `<i class="bi bi-chevron-right chev mr-1 text-slate-400"></i>`;
            const tag = n ? `<span class="entry-tag">${n} ${n === 1 ? 'entry' : 'entries'}</span>` : '';
            const st = w.status ? ` ${statusChip(w.status)}` : '';
            const gps = w.worker_id ? `<button class="wr-gps-btn ml-2 inline-flex items-center gap-1 text-[11px] font-medium rounded px-2 py-0.5 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 border border-indigo-200 align-middle" title="GPS activity"><i class="bi bi-geo-alt-fill"></i> GPS</button>` : '';
            return `<td class="l">${chev}<b>${w.name}</b>${tag}${st}${gps}</td>`;
          }
          if (c.src === 'date' || c.src === 'block' || c.src === 'sub_block') return blank;
          return numCell(c, w);
        }).join('') + `</tr>`;
        (w.entries || []).forEach(e => {
          html += `<tr class="sub sub-${i} hidden">` + cols.map(c => {
            if (c.src === 'name') return `<td class="l"></td>`;
            if (c.src === 'date') return `<td class="l"><span class="pl-6 text-slate-500"><i class="bi bi-calendar3 mr-1 text-slate-300"></i>${fdate(e.date)}</span></td>`;
            if (c.src === 'block') return `<td class="l">${e.block || '—'}</td>`;
            if (c.src === 'sub_block') return `<td class="l"><span class="text-slate-400">${e.sub_block || '—'}</span></td>`;
            return numCell(c, e);
          }).join('') + `</tr>`;
        });
      });
      $('#wr-tbody').html(html);

      // Footer totals
      const t = p.totals || {};
      $('#wr-tfoot').html('<tr>' + cols.map((c, ci) => {
        if (ci === 0) return '<td class="l">TOTAL</td>';
        if (c.src === 'date' || c.src === 'block' || c.src === 'sub_block') return '<td></td>';
        return numCell(c, t);
      }).join('') + '</tr>');
    }

    function fetchData() {
      const data = { month: $('#wr-month').val() || '' };   // 'YYYY-MM'
      const blk = $('#wr-block').val();
      if (blk) data.block_ids = blk;
      const wk = $('#wr-worker').val();
      if (wk) data.worker_id = wk;
      $('#wr-placeholder').addClass('hidden');
      $('#wr-results').removeClass('hidden');
      $('#wr-tbody').html(`<tr><td colspan="20" class="l text-slate-400 py-6">Loading…</td></tr>`);
      $.ajax({ url: '/api/report/worker/data', method: 'GET', data: data })
        .done(render)
        .fail(xhr => {
          $('#wr-tbody').empty();
          Toast.show('Failed to load report: ' + (xhr.responseJSON && xhr.responseJSON.error || xhr.statusText), 'error', 4000);
        });
    }

    function exportCsv() {
      if (!current) return;
      const cols = current.columns || [];
      const esc = v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"';
      const rows = [cols.map(c => esc(c.label)).join(',')];
      (current.workers || []).forEach(w => {
        rows.push(cols.map(c => esc(c.src === 'name' ? w.name
          : (c.src === 'date' || c.src === 'block' || c.src === 'sub_block') ? ''
            : plainCell(c, w))).join(','));
        (w.entries || []).forEach(e => {
          rows.push(cols.map(c => esc(c.src === 'name' ? ''
            : c.src === 'date' ? fdate(e.date)
              : (c.src === 'block' || c.src === 'sub_block') ? (e[c.src] || '')
                : plainCell(c, e))).join(','));
        });
      });
      const t = current.totals || {};
      rows.push(cols.map((c, ci) => esc(ci === 0 ? 'TOTAL'
        : (c.src === 'date' || c.src === 'block' || c.src === 'sub_block') ? ''
          : plainCell(c, t))).join(','));
      const blob = new Blob([rows.join('\n')], { type: 'text/csv' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'worker-productivity-harvesting.csv';
      a.click(); URL.revokeObjectURL(a.href);
    }

    // ── GPS Activity drawer (per worker) ─────────────────────────────────────────
    // Reuses the same heatmap/path/timeline view as the legacy Worker Productivity
    // report, but launched from a worker row and scoped to the report's month filter.
    let gpsCtrl = null;

    function gpsParsePoints(messages) {
      const pts = [];
      (messages || []).forEach(m => {
        try {
          const payload = JSON.parse(m.string_value);
          if (!payload.latitude || !payload.longitude) return;
          pts.push({ lat: parseFloat(payload.latitude), lng: parseFloat(payload.longitude), timestamp: new Date(m.time / 1000000) });
        } catch (e) {}
      });
      pts.sort((a, b) => a.timestamp - b.timestamp);
      return pts;
    }
    function gpsBlockFeatures() {
      if (typeof blocks === 'undefined' || !blocks || !blocks.features) return [];
      return blocks.features.filter(f => f.geometry).map(f => ({
        name: f.name || (f.properties && f.properties.name) || 'Unnamed',
        poly: { type: 'Feature', geometry: f.geometry, properties: {} }
      }));
    }
    function gpsBlockForPoint(p, feats) {
      if (typeof turf === 'undefined') return null;
      const pt = turf.point([p.lng, p.lat]);
      for (const f of feats) { try { if (turf.booleanPointInPolygon(pt, f.poly)) return f; } catch (e) {} }
      return null;
    }
    function gpsBuildTimeline(points, feats) {
      const segs = []; let cur = null;
      points.forEach(p => {
        const b = gpsBlockForPoint(p, feats);
        const name = b ? b.name : null;
        if (cur && cur.name === name) cur.end = p.timestamp;
        else { if (cur) segs.push(cur); cur = { name, start: p.timestamp, end: p.timestamp }; }
      });
      if (cur) segs.push(cur);
      return segs;
    }
    const gpsDur = ms => { if (ms < 60000) return Math.round(ms / 1000) + 's'; const t = Math.round(ms / 60000), h = Math.floor(t / 60), mm = t % 60; return h && mm ? `${h}h ${mm}m` : h ? `${h}h` : `${mm}m`; };
    const gpsTime = d => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const gpsDateTime = d => d.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' }) + ' ' + gpsTime(d);

    const gpsHeat = points => L.heatLayer(points.map(p => [p.lat, p.lng, 0.6]), { radius: 30, blur: 20, maxZoom: 17, gradient: { 0.2: 'blue', 0.4: 'cyan', 0.6: 'lime', 0.8: 'yellow', 1.0: 'red' } });
    const gpsPath = points => L.polyline(points.map(p => [p.lat, p.lng]), { color: '#2563eb', weight: 3, opacity: 0.8, dashArray: '5, 10' });
    function gpsMarkers(points) {
      const g = L.layerGroup();
      points.forEach((p, i) => {
        const latest = i === points.length - 1;
        L.circleMarker([p.lat, p.lng], { radius: latest ? 8 : 5, fillColor: latest ? '#2563eb' : '#ef4444', color: 'white', weight: 2, opacity: 1, fillOpacity: 0.85 })
          .bindPopup(`<div class="text-sm"><b>${latest ? 'Latest Position' : 'GPS Point'}</b><br>Lat: ${p.lat.toFixed(6)}<br>Lng: ${p.lng.toFixed(6)}<br>Time: ${p.timestamp.toLocaleString()}</div>`)
          .addTo(g);
      });
      return g;
    }
    function gpsBlocksOverlay(map) {
      if (typeof blocks === 'undefined' || !blocks) return;
      L.geoJSON(blocks, {
        style: { color: 'rgba(0,0,0,0.47)', weight: 1, fillColor: 'rgba(66,255,69,0.19)', fillOpacity: 0.5 },
        onEachFeature: (f, l) => { const n = f.name || (f.properties && f.properties.name) || 'Unnamed'; l.bindTooltip(n, { permanent: true, direction: 'center', className: 'custom-tooltip' }); }
      }).addTo(map);
    }

    function gpsClearLayers(ctrl) {
      [ctrl.heat, ctrl.path, ctrl.markers, ctrl.seg].forEach(l => { if (l && ctrl.map.hasLayer(l)) ctrl.map.removeLayer(l); });
    }
    function gpsShowView(ctrl, view) {
      ctrl.view = view;
      gpsClearLayers(ctrl);
      const $root = $(ctrl.root || document);
      const tl = $root.find('#gps-drawer-timeline')[0];
      if (view === 'heatmap') { ctrl.map.addLayer(ctrl.heat); if (tl) tl.classList.add('hidden'); }
      else if (view === 'timeline') { ctrl.map.addLayer(ctrl.path); if (tl) tl.classList.remove('hidden'); }
      else { ctrl.map.addLayer(ctrl.path); ctrl.map.addLayer(ctrl.markers); if (tl) tl.classList.add('hidden'); }
      $root.find('.gps-view-btn').each(function () { const active = $(this).data('view') === view; this.className = 'gps-view-btn px-3 py-1 text-sm rounded ' + (active ? 'bg-blue-100 text-blue-700' : 'border border-slate-200 hover:bg-slate-50'); });
      // leaving the timeline view clears any per-segment row highlight
      $root.find('.gps-seg-row').removeClass('bg-blue-100');
      setTimeout(() => ctrl.map.invalidateSize(), 60);
    }

    function gpsRenderTimeline(ctrl) {
      const segs = ctrl.segments;
      let inside = 0, outside = 0; const visited = new Set();
      const rows = segs.map((s, i) => {
        const dur = s.end - s.start, isIn = !!s.name;
        if (isIn) { inside += dur; visited.add(s.name); } else outside += dur;
        const badge = isIn
          ? `<span class="inline-flex items-center gap-1 bg-emerald-100 text-emerald-700 text-xs px-2 py-0.5 rounded-full"><i class="bi bi-geo-alt"></i>${s.name}</span>`
          : `<span class="inline-flex items-center gap-1 bg-slate-100 text-slate-500 text-xs px-2 py-0.5 rounded-full"><i class="bi bi-geo"></i>Undefined</span>`;
        return `<tr class="gps-seg-row cursor-pointer hover:bg-blue-50 border-t border-slate-100" data-seg="${i}">` +
          `<td class="px-3 py-2 text-sm text-slate-500">${i + 1}</td>` +
          `<td class="px-3 py-2">${badge}</td>` +
          `<td class="px-3 py-2 text-sm text-slate-700 whitespace-nowrap">${gpsDateTime(s.start)} <span class="text-slate-400">→</span> ${gpsTime(s.end)}</td>` +
          `<td class="px-3 py-2 text-sm font-medium text-right whitespace-nowrap">${gpsDur(dur)}</td></tr>`;
      }).join('');
      const head = `<div class="flex flex-wrap gap-4 text-xs text-slate-600 p-3 bg-slate-50 border-b border-slate-200">` +
        `<span>Inside blocks: <b class="text-emerald-700">${gpsDur(inside)}</b></span>` +
        `<span>Undefined: <b>${gpsDur(outside)}</b></span>` +
        `<span>Blocks visited: <b>${visited.size}</b></span>` +
        `<span class="text-slate-400 ml-auto"><i class="bi bi-hand-index"></i> click a row to show only that segment</span></div>`;
      const $root = $(ctrl.root || document);
      $root.find('#gps-drawer-timeline').html(head +
        `<div class="max-h-72 overflow-y-auto"><table class="w-full"><tbody>${rows}</tbody></table></div>`);
      $root.find('#gps-drawer-timeline').off('click.gps', '.gps-seg-row').on('click.gps', '.gps-seg-row', function () {
        gpsHighlightSegment(ctrl, +$(this).data('seg'), this);
      });
    }

    function gpsHighlightSegment(ctrl, index, rowEl) {
      const s = ctrl.segments[index]; if (!s) return;
      gpsClearLayers(ctrl);
      const segPoints = ctrl.points.filter(p => p.timestamp >= s.start && p.timestamp <= s.end);
      const g = L.layerGroup();
      if (segPoints.length > 1) g.addLayer(L.polyline(segPoints.map(p => [p.lat, p.lng]), { color: '#7c3aed', weight: 4, opacity: 0.9 }));
      segPoints.forEach((p, i) => {
        const first = i === 0, last = i === segPoints.length - 1;
        g.addLayer(L.circleMarker([p.lat, p.lng], { radius: (first || last) ? 7 : 4, fillColor: first ? '#10b981' : last ? '#ef4444' : '#7c3aed', color: 'white', weight: 2, fillOpacity: 0.9 })
          .bindPopup(`<div class="text-sm"><b>${first ? 'Start' : last ? 'End' : 'Point'}</b><br>${p.timestamp.toLocaleString()}</div>`));
      });
      ctrl.seg = g; ctrl.map.addLayer(g);
      if (segPoints.length) ctrl.map.fitBounds(L.latLngBounds(segPoints.map(p => [p.lat, p.lng])).pad(0.3), { maxZoom: 19 });
      $(ctrl.root || document).find('.gps-seg-row').removeClass('bg-blue-100');
      $(rowEl).addClass('bg-blue-100');
      Toast.show(`${s.name || 'Undefined'} · ${gpsDateTime(s.start)} → ${gpsTime(s.end)} · ${segPoints.length} pts`, 'info', 3500);
    }

    function gpsInit(resp, root) {
      root = root || document;                 // scope all lookups to THIS drawer (re-open race)
      const $root = $(root);
      const points = gpsParsePoints(resp.messages);
      const mapEl = root.querySelector ? root.querySelector('#gps-drawer-map') : document.getElementById('gps-drawer-map');
      if (!points.length) {
        if (mapEl) mapEl.classList.add('hidden');
        const e = $root.find('#gps-drawer-empty'); if (e.length) e.removeClass('hidden');
        $root.find('.gps-view-btn').prop('disabled', true).addClass('opacity-40 cursor-not-allowed');
        return;
      }
      const feats = gpsBlockFeatures();
      const cLat = points.reduce((s, p) => s + p.lat, 0) / points.length;
      const cLng = points.reduce((s, p) => s + p.lng, 0) / points.length;
      const map = L.map(mapEl, { maxZoom: 21 }).setView([cLat, cLng], 16);   // element, not id
      if (window.EstateMap) EstateMap.addBasemap(map);
      else L.tileLayer('https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', { subdomains: ['0', '1', '2', '3'], maxZoom: 21 }).addTo(map);
      gpsBlocksOverlay(map);
      const ctrl = { root, map, points, segments: gpsBuildTimeline(points, feats), heat: gpsHeat(points), path: gpsPath(points), markers: gpsMarkers(points), seg: null, view: 'path' };
      gpsCtrl = ctrl;
      gpsRenderTimeline(ctrl);
      gpsShowView(ctrl, 'path');
      $root.find('.gps-view-btn').off('click.gps').on('click.gps', function () { gpsShowView(ctrl, $(this).data('view')); });
      setTimeout(() => map.invalidateSize(), 350);
    }

    function gpsDrawerUI(w, resp) {
      const dev = resp.device || {};
      const content = `
        <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between flex-wrap gap-2">
            <div class="text-sm text-slate-500"><i class="bi bi-cpu"></i> ${dev.name || 'Device'} <span class="text-slate-400">· ${resp.from_date} → ${resp.to_date}</span></div>
            <div class="flex items-center gap-2">
              <button class="gps-view-btn px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded" data-view="path">Path</button>
              <button class="gps-view-btn px-3 py-1 text-sm border border-slate-200 rounded hover:bg-slate-50" data-view="heatmap">Heatmap</button>
              <button class="gps-view-btn px-3 py-1 text-sm border border-slate-200 rounded hover:bg-slate-50" data-view="timeline"><i class="bi bi-list-ul"></i> Timeline</button>
            </div>
          </div>
          <div id="gps-drawer-map" class="w-full rounded-lg border border-slate-200" style="height:56vh"></div>
          <div id="gps-drawer-empty" class="hidden text-center text-slate-400 py-8"><i class="bi bi-geo text-2xl"></i><p class="text-sm mt-2">No GPS points for ${resp.from_date} → ${resp.to_date}.</p></div>
          <div id="gps-drawer-timeline" class="hidden border border-slate-200 rounded-lg overflow-hidden"></div>
        </div>`;
      const dlg = new Drawer('GPS Activity — ' + (w.name || ''), content, { side: 'right', width: 'w-full' });
      dlg.setButtons([{ name: 'Close', dismiss: true }]);
      dlg.setEvents([
        { action: 'show', callback: (ev) => { const d = ev && ev.data && ev.data.drawer; try { if (d) { d.style.width = '100%'; d.style.maxWidth = '900px'; } } catch (e) {} gpsInit(resp, d); } },
        { action: 'hide', callback: () => { if (gpsCtrl && gpsCtrl.map) { try { gpsCtrl.map.remove(); } catch (e) {} } gpsCtrl = null; } },
      ]);
      dlg.show();
    }

    function openGpsDrawer(w) {
      if (!w || !w.worker_id) { Toast.show('No worker selected.', 'error', 3000); return; }
      const month = $('#wr-month').val() || '';
      $.ajax({ url: '/api/report/worker/gps', method: 'GET', data: { worker_id: w.worker_id, month } })
        .done(resp => {
          if (!resp.has_device) { Toast.show((w.name || 'This worker') + ' has no device assigned.', 'warning', 4000); return; }
          gpsDrawerUI(w, resp);
        })
        .fail(xhr => Toast.show('Failed to load GPS: ' + (xhr.responseJSON && xhr.responseJSON.error || xhr.statusText), 'error', 4000));
    }

    $(function () {
      // Default to the current month.
      const now = new Date(), y = now.getFullYear(), pad = n => String(n).padStart(2, '0');
      $('#wr-month').val(`${y}-${pad(now.getMonth() + 1)}`);

      // ── Worker Dropdown (custom select with lazy-load on scroll) ──
      const WR_PAGE_SIZE = 15;
      let wrWorkerOffset = 0;
      let wrWorkerTotal  = 0;
      let wrWorkerLoading = false;
      let wrWorkerQuery   = '';
      let wrSearchTimeout = null;

      const $wrBtn     = $('#wr-worker-btn');
      const $wrMenu    = $('#wr-worker-menu');
      const $wrSearch  = $('#wr-worker-search');
      const $wrOpts    = $('#wr-worker-options');
      const $wrLoader  = $('#wr-worker-loader');
      const $wrLabel   = $('#wr-worker-label');
      const $wrHidden  = $('#wr-worker');

      function wrRenderUser(user) {
        const firstName = user.first_name || '';
        const lastName = user.last_name || '';
        const name = (firstName + ' ' + lastName).trim() || user.username || 'Unnamed';
        return $(`<div class="wr-wopt px-4 py-3 hover:bg-slate-50 cursor-pointer border-b border-slate-100 last:border-b-0 flex flex-col" data-value="${user.id}">
          <div class="font-medium text-sm text-slate-900">${name}</div>
          <div class="text-xs text-slate-600 mt-1 flex items-center gap-2">
            <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded font-mono">${user.emp_id || '-'}</span>
            <span class="font-mono">${user.username || 'N/A'}</span>
          </div>
        </div>`);
      }

      function wrFetchWorkers(append) {
        if (wrWorkerLoading) return;
        if (append && wrWorkerOffset >= wrWorkerTotal && wrWorkerTotal > 0) return;  // no more pages
        wrWorkerLoading = true;
        $wrLoader.removeClass('hidden').addClass('flex');

        searchUserPaginated({ limit: WR_PAGE_SIZE, offset: wrWorkerOffset, query: wrWorkerQuery })
          .done(function (resp) {
            const users = resp.users || [];
            wrWorkerTotal = resp.total || 0;
            if (!append) {
              // keep the "All workers" option, clear the rest
              $wrOpts.find('.wr-wopt:not([data-value=""])').remove();
              $wrOpts.find('.wr-wopt-empty').remove();
            }
            if (users.length === 0 && wrWorkerOffset === 0) {
              $wrOpts.append('<div class="wr-wopt-empty px-4 py-3 text-sm text-slate-400 text-center">No workers found</div>');
            } else {
              users.forEach(function (u) { $wrOpts.append(wrRenderUser(u)); });
            }
            wrWorkerOffset += users.length;
          })
          .always(function () {
            wrWorkerLoading = false;
            $wrLoader.addClass('hidden').removeClass('flex');
          });
      }

      // Toggle dropdown open / close
      $wrBtn.on('click', function (e) {
        e.stopPropagation();
        const isOpen = !$wrMenu.hasClass('hidden');
        if (isOpen) {
          $wrMenu.addClass('hidden').removeClass('flex');
          return;
        }
        // Reset and open
        wrWorkerQuery = '';
        wrWorkerOffset = 0;
        wrWorkerTotal = 0;
        $wrSearch.val('');
        $wrOpts.find('.wr-wopt:not([data-value=""])').remove();
        $wrOpts.find('.wr-wopt-empty').remove();
        $wrMenu.removeClass('hidden').addClass('flex');
        $wrSearch.focus();
        wrFetchWorkers(false);
      });

      // Close on outside click
      $(document).on('click', function (e) {
        if (!$(e.target).closest('#wr-worker-select').length) {
          $wrMenu.addClass('hidden').removeClass('flex');
        }
      });

      // Search input inside dropdown
      $wrSearch.on('click', function (e) { e.stopPropagation(); });
      $wrSearch.on('input', function () {
        clearTimeout(wrSearchTimeout);
        const query = $wrSearch.val().trim();
        wrSearchTimeout = setTimeout(function () {
          if (query.length > 0 && query.length < 3) {
            Toast.show("Please enter at least 3 characters", "error", 3000);
            return;
          }
          wrWorkerQuery = query;
          wrWorkerOffset = 0;
          wrWorkerTotal = 0;
          wrFetchWorkers(false);
        }, 400);
      });

      // Infinite scroll — when user scrolls near the bottom, load more
      $wrOpts.on('scroll', function () {
        const el = this;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
          wrFetchWorkers(true);
        }
      });

      // Click on a worker option (delegated)
      $wrOpts.on('click', '.wr-wopt', function (e) {
        e.stopPropagation();
        const val = $(this).attr('data-value');
        const text = $(this).find('.font-medium').text() || $(this).text();
        $wrLabel.text(val ? text.trim() : 'All workers');
        $wrHidden.val(val).trigger('change');
        $wrMenu.addClass('hidden').removeClass('flex');
      });

      $('#wr-apply').on('click', fetchData);
      $('#wr-csv').on('click', exportCsv);
      $('#wr-print').on('click', () => window.print());

      // Delegated row click (bound once): the GPS button opens the GPS drawer; anywhere
      // else on the worker row expands its dated entries.
      $('#wr-tbody').on('click', '.grp-row', function (e) {
        const i = +$(this).attr('data-i');
        if ($(e.target).closest('.wr-gps-btn').length) {
          openGpsDrawer(((current && current.workers) || [])[i]);
          return;
        }
        $('.sub-' + i).toggleClass('hidden');
        $(this).find('.chev').toggleClass('open');
        $(this).toggleClass('open');
      });
      // No auto-load: the page opens on the filter; results appear only after Apply.
    });
  })();
}
